import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BoxInfoRouterService } from '../box-info-router/box-info-router.service';
import { StatusRoteiroPedidos, Util } from '../shared/Util';
import { AlteracaoComprovante, JsonReturn, ObjectParam } from '../shared/interface/generic-interface';
import { ApiConService } from '../shared/api-con.service';
import { NotificationService } from '../shared/notification.service';
import { NgIf, DatePipe } from '@angular/common';
import { DualInfoComponentComponent } from '../shared/componentes/dual-info-component/dual-info-component.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TextoLinkComponent } from '../shared/componentes/texto-link/texto-link.component';
import { BotaoPrimarioComponent } from '../shared/componentes/botao-primario/botao-primario.component';


declare let jsPDF;
@Component({
    selector: 'app-popup-dados-recebedor',
    templateUrl: './popup-dados-recebedor.component.html',
    styleUrls: ['./popup-dados-recebedor.component.css'],
    standalone: true,
    imports: [NgIf, DualInfoComponentComponent, NgbTooltip, TextoLinkComponent, BotaoPrimarioComponent, DatePipe]
})
export class PopupDadosRecebedorComponent{ 

  novoComprovante = ''

  constructor(
    public boxInfoRouterService: BoxInfoRouterService, 
    private conService: ApiConService,
    private notificationService: NotificationService
  ){}

  downloadPDFRecibo() {
    console.log(this.boxInfoRouterService.dadosComprovante)
    let item = this.boxInfoRouterService.dadosComprovante,
      numeroNota = 26;

    let imgData = 'data:image/jpeg;base64,' + item.Arquivo;

    const doc = new jsPDF('l', 'mm', [297, 260]), // paisagem
      titulos = 16,
      informacaoes = 26,
      data = 26;

    let alturaImagem = 28;

    doc.setDrawColor(0);
    doc.setFillColor(255, 255, 255);

    // Cabeçalho
    doc.text(8, titulos, 'DATA');
    doc.setFontType('bold');
    doc.setFontSize(16);
    doc.text(
      8,
      data,
      new Date(item.dataFinalEntrega).toLocaleString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    );

    doc.setFontType('normal');
    doc.text(69, titulos, 'IDENTIFICAÇÃO');
    doc.setFontType('bold');
    doc.text(109, informacaoes, item.NomeRecebedor.substring(0, 25));
    doc.text(200, informacaoes, item.DocumentoRecebedor);
    doc.setFontType('normal');
    doc.text(180, informacaoes, 'DOC.:');
    doc.text(69, informacaoes, 'RECEBEDOR:');
    doc.text(252, titulos, 'NF-E');

    // Pedidos
    item.pedidos.forEach((pedido) => {
      if (
        pedido.IdRoteiroPedidoSituacao == StatusRoteiroPedidos.EntregaFinalizada
      ) {
        doc.setFontType('normal');
        doc.text(252, numeroNota, `Nº `);
        doc.setFontType('bold');
        doc.text(260, numeroNota, `${pedido.Nf}`);
        numeroNota += 6;
        alturaImagem += 4;
      }
    });

    doc.setFontType('normal');

    // corrige orientação da imagem antes de inserir no PDF
    this.fixOrientation(imgData, (fixedImg) => {
      try {
        const tempImg = new Image();
        tempImg.onload = () => {
          // Dimensões da imagem original em pixels
          const imgWidth = tempImg.width;
          const imgHeight = tempImg.height;
          
          // Área disponível no PDF
          const pdfWidth = 297 - 16; // largura total - margens (8mm de cada lado)
          const pdfMaxHeight = 260 - (alturaImagem + 10) - 10; // altura disponível menos posição inicial e margem inferior
          const posX = 8;
          const posY = alturaImagem + 10;
          
          // Converter dimensões de pixels para mm (96 DPI padrão)
          const imgWidthMM = (imgWidth * 25.4) / 96;
          const imgHeightMM = (imgHeight * 25.4) / 96;
          
          // Calcular escalas necessárias para caber no PDF
          const scaleWidth = pdfWidth / imgWidthMM;
          const scaleHeight = pdfMaxHeight / imgHeightMM;
          
          // Usar a menor escala para garantir que caiba, mas com mínimo de 0.7 para não ficar muito pequeno
          let scale = Math.min(scaleWidth, scaleHeight);
          scale = Math.max(scale, 0.7); // garantir tamanho mínimo
          
          // Se mesmo com escala mínima ultrapassar, usar o que couber
          if (imgWidthMM * scale > pdfWidth) {
            scale = pdfWidth / imgWidthMM;
          }
          if (imgHeightMM * scale > pdfMaxHeight) {
            scale = pdfMaxHeight / imgHeightMM;
          }
          
          const finalWidth = imgWidthMM * scale;
          const finalHeight = imgHeightMM * scale;
          
          // Centralizar horizontalmente se a imagem for menor que a largura disponível
          const finalPosX = finalWidth < pdfWidth ? posX + (pdfWidth - finalWidth) / 2 : posX;
          
          doc.addImage(fixedImg, 'JPEG', finalPosX, posY, finalWidth, finalHeight);
          
          let nomeArquivo = '';
          item.pedidos.forEach((pedido) => {
            if (
              pedido.IdRoteiroPedidoSituacao ==
              StatusRoteiroPedidos.EntregaFinalizada
            ) {
              nomeArquivo += `NF_${pedido.Nf}`;
            }
          });

          doc.save(`${nomeArquivo}.pdf`);
        };
        tempImg.src = fixedImg;
      } catch (error) {
        console.log('Erro ao adicionar JPEG, tentando PNG');
        let fallbackImg = 'data:image/png;base64,' + item.Arquivo;
        this.fixOrientation(fallbackImg, (fixedPng) => {
          const tempImg = new Image();
          tempImg.onload = () => {
            const imgWidth = tempImg.width;
            const imgHeight = tempImg.height;
            const pdfWidth = 297 - 16;
            const pdfMaxHeight = 260 - (alturaImagem + 10) - 10;
            const posX = 8;
            const posY = alturaImagem + 10;
            
            const imgWidthMM = (imgWidth * 25.4) / 96;
            const imgHeightMM = (imgHeight * 25.4) / 96;
            
            const scaleWidth = pdfWidth / imgWidthMM;
            const scaleHeight = pdfMaxHeight / imgHeightMM;
            
            let scale = Math.min(scaleWidth, scaleHeight);
            scale = Math.max(scale, 0.7);
            
            if (imgWidthMM * scale > pdfWidth) {
              scale = pdfWidth / imgWidthMM;
            }
            if (imgHeightMM * scale > pdfMaxHeight) {
              scale = pdfMaxHeight / imgHeightMM;
            }
            
            const finalWidth = imgWidthMM * scale;
            const finalHeight = imgHeightMM * scale;
            const finalPosX = finalWidth < pdfWidth ? posX + (pdfWidth - finalWidth) / 2 : posX;
            
            doc.addImage(fixedPng, 'PNG', finalPosX, posY, finalWidth, finalHeight);
            
            let nomeArquivo = '';
            item.pedidos.forEach((pedido) => {
              if (
                pedido.IdRoteiroPedidoSituacao ==
                StatusRoteiroPedidos.EntregaFinalizada
              ) {
                nomeArquivo += `NF_${pedido.Nf}`;
              }
            });

            doc.save(`${nomeArquivo}.pdf`);
          };
          tempImg.src = fixedPng;
        });
      }
    });
  }


  private fixOrientation(imgData: string, callback: (fixedImg: string) => void) {
    const img = new Image();
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      const isPortrait = height > width;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;

      if (isPortrait) {
        canvas.width = height;
        canvas.height = width;

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(-90 * Math.PI / 180);
        ctx.drawImage(img, -width / 2, -height / 2);
      } else {
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0);
        }

        callback(canvas.toDataURL('image/jpeg', 1.0));
    };

    img.onerror = () => callback(imgData);
    img.src = imgData;
  }

  anexarArquivos(){
    document.getElementById('inputFileComprovante').click()
  }

  async selecionaArquivos(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      const url = new URL(window.location.href);
      const reader = new FileReader(); 
      let alteracaoComp: AlteracaoComprovante;
      let responseJsonReturn: JsonReturn;
      let response: JsonReturn;
      let usuario: any = url.searchParams.get('opc3');
      usuario = atob(usuario);


      reader.onload = async () => {
        const base64 = reader.result as string;
        const base64SemPrefixo = base64.split(',')[1];
        this.boxInfoRouterService.dadosComprovante.Arquivo = base64SemPrefixo;
        
        const numeroPedidos: Array<number> = this.boxInfoRouterService.dadosComprovante.pedidos
        .filter((pedido) => pedido.EntregaRealizada)
        .map((ped) => ped.NumeroPedido);
        
        const original = new Date(this.boxInfoRouterService.dadosComprovante.dataFinalEntrega);
        const dataEntrega = new Date(original.getTime() - original.getTimezoneOffset() * 60000);
        const objParam: ObjectParam = {
            pedidoConfirmacaoEntrega: {
              comprovante: 'ATUALIZACAO RADAR',
              arquivo: Util.compress(this.boxInfoRouterService.dadosComprovante.Arquivo),
              dataEntrega:  dataEntrega,
              nomeRecebedor:  this.boxInfoRouterService.dadosComprovante.NomeRecebedor,
              documentoRecebedor:  this.boxInfoRouterService.dadosComprovante.DocumentoRecebedor,
              pedidosRecebidos : numeroPedidos
            }
        };  

        response = await this.conService.post('DCPedidoConfirmacaoEntrega/' + this.boxInfoRouterService.dadosComprovante.NumeroRoteiro, objParam);

        if(!response.sucesso){
          this.notificationService.showErro('Erro ao atualizar comprovante');
          return;
        }      

        const idPedidoConfirmacaoEntrega = response.response[0].IdPedidoConfirmacaoEntrega;
        for (var i = 0; i < this.boxInfoRouterService.dadosComprovante.pedidos.length; i++) {       
          alteracaoComp = {
            IdRoteiro : this.boxInfoRouterService.dadosComprovante.IdRoteiro,
            IdRoteiroPedido : this.boxInfoRouterService.dadosComprovante.pedidos[i].IdRoteiroPedido,
            ValorAnterior: this.boxInfoRouterService.dadosComprovante.IdPedidoConfirmacaoEntrega,
            ValorNovo: idPedidoConfirmacaoEntrega,
            Usuario: usuario
          }
          const objParam: ObjectParam = {
            alteracaoComprovante : alteracaoComp
          };  
          
          responseJsonReturn = await this.conService.post('DCAlteracaoComprovante', objParam);
 
        } 
      };

      reader.readAsDataURL(file);
      }
    }
   
  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img.naturalHeight > img.naturalWidth) {
      img.style.transform = 'rotate(-90deg)';
    } else {
      img.style.transform = 'rotate(0deg)';
    }
  }
}
